import { Component, OnInit } from '@angular/core';
import { CmsComponentData, MediaComponent } from '@spartacus/storefront';
import { ImageTextComponentData } from '../../model/image-text.model';
import { TileLinkComponent } from '../tile-link/tile-link.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-image-text',
    templateUrl: './image-text.component.html',
    imports: [MediaComponent, TileLinkComponent, AsyncPipe]
})
export class ImageTextComponent {
  constructor(public component: CmsComponentData<ImageTextComponentData>) {}

  round(n: number) {
    return Math.round(n);
  }
}
